import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "@/i18n/translations";

const LanguageContext = createContext();

function detectLanguage() {
  const stored = localStorage.getItem("rpg-lang");
  if (stored && (stored === "es" || stored === "en")) return stored;
  const browserLang = navigator.language || navigator.userLanguage || "en";
  return browserLang.startsWith("es") ? "es" : "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLanguage);

  useEffect(() => {
    localStorage.setItem("rpg-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const toggleLang = () => setLang((prev) => (prev === "es" ? "en" : "es"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
}
